import React from 'react';

import { Divider } from '@mui/material';

type Props = {
  placement: 'top' | 'left-start';
};

export default function TuneMenuDivider({ placement }: Props) {
  switch (placement) {
    case 'left-start':
      return <Divider sx={{ my: 1 }} />;
    case 'top':
      return <Divider flexItem sx={{ mx: 1 }} orientation="vertical" />;
  }
}
